import { render, staticRenderFns } from "./svgIcon.vue?vue&type=template&id=68e460de&"
import script from "./svgIcon.vue?vue&type=script&lang=js&"
export * from "./svgIcon.vue?vue&type=script&lang=js&"
import style0 from "./svgIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports